import { type Theme } from "@mui/material/styles";

import { Box, type BoxProps } from "ui/box";
import { mergeSx } from "ui/merge-sx";

import { shadows } from "design-tokens";

const INSET_SHADOW = shadows.xs;

const BASE_SX = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 1.25,
};

const INSET_SX = (theme: Theme) => ({
  p: 0.75,
  borderRadius: 1,
  border: "1px solid",
  borderColor: theme.palette.divider,
  backgroundColor: theme.palette.grey[100],
  boxShadow: INSET_SHADOW,
});

type ControlBarProps = Omit<BoxProps, "variant"> & {
  variant?: "default" | "inset";
};

const ControlBar = ({ variant = "default", sx, ...rest }: ControlBarProps) => {
  return <Box sx={mergeSx(BASE_SX, variant === "inset" ? INSET_SX : undefined, sx)} {...rest} />;
};

export default ControlBar;
